import React, { Component, createRef } from "react";
import { PLACEHOLDER_IDENTIFIER } from "../../../constants/Constant";
import { replaceSelectionWithContent, restoreSelectionFromSavedRange } from "../../../managers/common/TextSelection";
import { pageDesignerCustomEvent, PAGE_DESIGNER_EVENTS } from "../../../services/event/commonEvents";
import Utility from "../../../utility/Utility";
import { getInnerPlaceholderHTML } from "./PlaceholderButton";

/*
PROPS
- data
- index
- borderStyle
- inlineEditing
*/
class Text extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inlineEditing: this.props.inlineEditing
        ? this.props.inlineEditing
        : false,
    };
    this.textComponentRef = createRef();
  }
  componentDidMount() {
    pageDesignerCustomEvent.on(PAGE_DESIGNER_EVENTS.PLACEHOLDER_SELECTED, this.onPlaceholderSelected);
  }
  componentWillUnmount() {
    this.setState({ inlineEditing: false });
    pageDesignerCustomEvent.remove(PAGE_DESIGNER_EVENTS.PLACEHOLDER_SELECTED, this.onPlaceholderSelected)
  }
  componentWillReceiveProps(nextProps) {
    this.setState(
      {
        inlineEditing: nextProps.inlineEditing,
      },
      () => {
        if (nextProps.inlineEditing === true) {
          this.selectedTextBox(this.props.index);
        }
      }
    );
  }
  render() {
    return (
      <div
        id={`textBox-${this.getTextComponentId()}`}
        ref={this.textComponentRef}
        contentEditable={this.state.inlineEditing}
        style={{
          ...this.props.data.style,
          ...this.props.borderStyle,
        }}
        dangerouslySetInnerHTML={{ __html: this.props.data.value }}
        onDoubleClick={() => {
          if(!this.props.isEditing) { return }
          this.setState({ inlineEditing: true }, () => {
            this.selectedTextBox(this.props.index);
          });
        }}
        onClick={(e) => {
          if (this.state.inlineEditing) {
            e.stopPropagation();
          }
        }}
        onBlur={(e) => {

          e.preventDefault();
          this.setState({ inlineEditing: false });
          let index = null, columnIndex = null, colComponentIndex = null;
          if ( !Utility.isEmpty(this.props.columnIndex)) {
            if (!Utility.isEmpty(this.props.colComponentIndex)) {
              index = this.props.componentIndex
              columnIndex = this.props.columnIndex
              colComponentIndex = this.props.colComponentIndex
            } else {
              index = this.props.index
              columnIndex = this.props.columnIndex
              colComponentIndex = null
            }
          } else {
            index = this.props.index
          }
          this.insertKeyForPlaceholders();
          this.props.onTextChange(e.target.innerHTML, index, columnIndex, colComponentIndex);
          this.props.onCloseInlineEdit();
          
        }}
      />
    );
  }
  insertKeyForPlaceholders = () => {
    const allCustomPlaceholderFields = this.textComponentRef?.current?.querySelectorAll(`.${PLACEHOLDER_IDENTIFIER}`);
    allCustomPlaceholderFields?.forEach((placeholderField) => {
      placeholderField.innerHTML = getInnerPlaceholderHTML(placeholderField.dataset.id, placeholderField.dataset.name);
    });
  }
  getTextComponentId = (componentData = this.props) => {
    const { index, componentIndex, columnIndex, colComponentIndex, textCompType } = componentData;
    let id = ""
    if (!Utility.isEmpty(columnIndex)) {
      if (!Utility.isEmpty(colComponentIndex)) {
        id = `${componentIndex}-${columnIndex}-${colComponentIndex}`;
      } else {
        id = `${index}-${columnIndex}`
      }

      id += textCompType || "";
    } else {
      id = index
    }
    return id;
  }
  onPlaceholderSelected = (eventData) => {
    const { componentData, placeholderData } = eventData?.detail;

    if(this.getTextComponentId() !== this.getTextComponentId(componentData)) return;

    const placeholderContainer = document.createElement("span");
    const placeholder = document.createElement("span");
    placeholder.className = PLACEHOLDER_IDENTIFIER;
    placeholder.dataset.id = placeholderData.id;
    placeholder.dataset.name = placeholderData.name;
    placeholder.innerHTML = getInnerPlaceholderHTML(placeholderData.id, placeholderData.name);

    placeholderContainer.appendChild(this.getNewTextElementToInsert());
    placeholderContainer.appendChild(placeholder);
    placeholderContainer.appendChild(this.getNewTextElementToInsert());
    this.setTextBoxSelection();
    const selectedRange = replaceSelectionWithContent(placeholderContainer, this.textComponentRef.current);
    this.enableInlineTextEdit(selectedRange);
  }
  getNewTextElementToInsert = (isLineBreak = false) => {
    const lineBreakSpan = document.createElement("span");
    lineBreakSpan.innerHTML = isLineBreak ? `\n&#xFEFF;` : `&#xFEFF;`;
    return lineBreakSpan;
  }
  enableInlineTextEdit = (selectedRange = null) => {
    if(this.props.enableInlineTextEdit) {
      this.props.enableInlineTextEdit();
    }    
    this.setState({ inlineEditing: true, selectedRange: selectedRange }, () => {
      this.setTextBoxSelection();
    });
  }
  setTextBoxSelection = () => {
    restoreSelectionFromSavedRange(this.state.selectedRange, this.textComponentRef.current);
  };
  selectedTextBox = (index) => {
    let textBox = document.getElementById("textBox-" + index);
    const range = document.createRange();
    const sel = window.getSelection();
    range.selectNodeContents(textBox);
    range.collapse(false);
    sel.removeAllRanges();
    sel.addRange(range);
    textBox.focus();
    range.detach();
  };
}

export default Text;
